import { Flex } from '@ifood/pomodoro-components';
import { FormattedMessage } from 'gatsby-plugin-intl';
import React from 'react';

import { useDialogState } from 'modules/UI';

import { NewsletterDialog } from '../NewsletterDialog';
import { Container, Content, Description, SubscribeButton, Title } from './styles';

const intlPrefix = 'home.newsletter';

type PropTypes = {
  showInformation?: boolean;
};

export const Newsletter = ({ showInformation }: PropTypes): JSX.Element => {
  const dialog = useDialogState();
  return (
    <>
      <Container>
        <Flex>
          <div>
            {showInformation && (
              <Title>
                <FormattedMessage id={`${intlPrefix}.title`} />
              </Title>
            )}
            <Content showInformation={showInformation}>
              {showInformation && (
                <Description>
                  <FormattedMessage id={`${intlPrefix}.description`} />
                </Description>
              )}
            </Content>
          </div>

          <Flex alignItems="center">
            <SubscribeButton
              onClick={(): void => {
                dialog.open();
              }}
            >
              {showInformation ? (
                <FormattedMessage id="subscribe" />
              ) : (
                <FormattedMessage id={`${intlPrefix}.subscribe`} />
              )}
            </SubscribeButton>
          </Flex>
        </Flex>
      </Container>

      <NewsletterDialog isOpen={dialog.isOpen} onCloseClick={dialog.reset} />
    </>
  );
};
